import {useCallback} from "react";
import {batch} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals"
import {resetPricingChangesSignals, priceChangesTableData, priceChangesOverview, priceChangesIsEmpty, priceChangesSubmittedFilters} from "../@signals";
import usePricingChangesRoleConfig from "./useRoleConfig";


export default function usePricingChangesFilters() {
	const { urlApi } = usePricingChangesRoleConfig()

	const handleSubmit = useCallback(values => {
		isLoadingCommonFilters.value = true
		isSystemBusy.value = false
		resetPricingChangesSignals()
		return postSubmit(urlApi, values).then(({ table, overview }) => {
			priceChangesSubmittedFilters.value = commonFiltersValue.peek()
			if (!table.length)
				priceChangesIsEmpty.value = true
			else batch(() => {
				priceChangesTableData.value = table
				priceChangesOverview.value = overview
			})
		}).catch(()=> isSystemBusy.value = true)
		.finally(() => isLoadingCommonFilters.value = false)
	}, [])

	return {
		handleSubmit
	}
}